// extracted by mini-css-extract-plugin
module.exports = {"iframe":"YouTubeModal_iframe__Mo5Na"};